import styled from 'styled-components';
import { COLORS, DEVICES, FONT_FAMILY } from '@Commons';

export const PopularCountriesContainer = styled.div`
  background: ${COLORS.white};
  max-width: 450px;
  width: 100%;
  flex-direction: column;
  padding: 16px 16px 32px;
  border-radius: 4px;
  display: flex;
  justify-items: center;
  align-items: flex-start;
  max-height: 600px;
  height: 100%;

  .popular-countries-container__close-icon-container {
    width: 100%;
    .close-icon-container__close-icon {
      cursor: pointer;
      height: 24px;
      width: 24px;
      margin-left: auto;
      float: right;
    }
  }
  .popular-countries-container__form {
    width: 100%;
    height: 100%;
    display: flex;
  }
  .popular-countries-container__container {
    width: 100%;
    height: 100%;
    display: flex;
    margin-top: 32px;
    justify-content: flex-start;
    align-items: flex-start;
    flex-direction: column;
    flex: 1;
    gap: 16px;
    padding-bottom: 16px;
    .input-error-wrapper {
      width: 100% !important;
    }
    #bank-account-country-dropdown {
      padding: 0 !important;
      display: flex !important;
      justify-content: flex-start;
      align-items: center;
      flex-direction: row;
      input {
        height: 100% !important;
        padding: 0 16px !important;
        margin-top: 2px;
      }

      .divider {
        color: rgba(115, 115, 115, 0.87);
        padding: 9px 16px !important;
        .avatar {
          opacity: 0.5;
        }
      }
    }
    .container__heading {
      width: 100%;
      font-size: 18px;
      text-align: center;
      font-weight: 700;
      font-family: ${FONT_FAMILY.hellix.bold};
      line-height: 26px;
      color: ${COLORS.black};
    }
    .container__button {
      width: 100%;
      margin-top: auto;
      height: 50px;
      min-height: 50px;
    }

    //flag image css
    .avatar {
      width: 24px;
      height: 24px;
      margin-bottom: 2px !important;
      margin-top: 0 !important;
    }
    .menu {
      max-height: 350px !important;
      .item {
        padding: 16px 18px !important;
      }
      .item.menu__country-dropdown-heading {
        color: ${COLORS.black} !important;
        font-family: ${FONT_FAMILY.hellix.bold} !important;
        font-size: 14px !important;
        opacity: 1 !important;
        font-weight: 700 !important;
        line-height: 22px !important;
        background-color: ${COLORS.white};
        &:hover {
          background-color: ${COLORS.white};
        }
      }
      .item.menu__country-dropdown-heading-empty {
        line-height: 0 !important;
        height: 0 !important;
        padding: 0 !important;
      }
    }
  }
  @media ${DEVICES.mobileXL} {
    max-height: 480px;
  }
`;
